import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Typography from 'Components/UI/Typography';
import Avatar from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Avatar';
import LinearProgress from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/LinearProgress';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import fr from 'facet-rest';
import useProfileImage from 'Hooks/useProfileImage';
import useComponentDidMount from 'Hooks/useComponentDidMount';

const styles = (theme) => ({
  root: {
    marginTop: theme.spacing(1),
    width: '100%',
    display: 'flex',
    height: 100,
    alignItems: 'center',
  },
  headerText: {
    width: '100%',
    marginLeft: theme.spacing(1.5),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    minWidth: 0,
  },
  titleText: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  navInfo: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
  },
  avatar: {
    width: 70,
    height: 70,
  },
  percent: {
    alignSelf: 'flex-end',
  },
  expanded: {
    transition: theme.transitions.create('all', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    opacity: 1,
  },
  compact: {
    transition: theme.transitions.create('all', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    opacity: 0,
    overflowX: 'hidden',
  },
});

const NavigationHeader = ({
  className,
  classes,
  clientResource,
  navigationResource,
  compact,
  AvatarProps,
}) => {
  const profileImageLink = clientResource.relationship(fr.relationships.profileImage.name)
    ? clientResource.relationship(fr.relationships.profileImage.name)?.link('related')
    : '';

  const { fetchProfileImage, profileImage } = useProfileImage({
    avatarLink: profileImageLink,
  });

  useComponentDidMount(() => {
    fetchProfileImage();
  });

  const avatar = (<Avatar src={profileImage} className={classes.avatar} {...AvatarProps} />);

  // TODO skeleton?
  if (!navigationResource) return null;
  return (
    <div className={classNames(classes.root, className)}>
      {avatar}
      <div
        className={classNames(classes.headerText, {
          [classes.expanded]: !compact,
          [classes.compact]: compact,
        })}
      >
        <Typography variant="h3" weight="medium" color="primary" noWrap className={classes.titleText}>
          {navigationResource.attr('title')}
        </Typography>
        <div className={classes.navInfo}>
          <Typography color="primary" className={classes.percent}>
            {`${navigationResource.attr('percentComplete')}% completed`}
          </Typography>
        </div>
        <LinearProgress
          color="primaryToAccentBlue"
          variant="determinate"
          value={parseInt(navigationResource.attr('percentComplete'), 10)}
        />
      </div>
    </div>
  );
};

NavigationHeader.defaultProps = {
  className: '',
  compact: false,
  AvatarProps: {},
};

NavigationHeader.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  clientResource: PropTypes.object.isRequired,
  navigationResource: PropTypes.object.isRequired,
  compact: PropTypes.bool,
  AvatarProps: PropTypes.object,
};

export default withStyles(styles)(NavigationHeader);
